module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<header></header> <div class=\"card card-body filter-card\"> <div id=\"api_mode_selector\" class=\"mr-sm-4 mb-3 mb-sm-0\"></div> <div id=\"bol_daterange_pickers\" class=\"mr-sm-4 mb-2 mb-sm-0\"></div> <div id=\"create_bol\" class=\"mr-4 mb-0 d-none d-md-block\"></div> <a href=\"/assets/csvs/EP_BOL_Template.csv\" target=\"_blank\" id=\"download_template\" class=\"mr-4 mb-0 d-none d-xl-block btn btn-primary filter-card-btn\">Download BOL Template</a> </div> <div id=\"bol_search\" class=\"card card-body search-card\"></div> <div id=\"bol_list\"></div> <div id=\"bol_pagination\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/fulfillment_bols/template.ejs
// module id = 1666
// module chunks = 1